function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { T } from "@supersig/validate";
import { cssTypeMap } from "./css";
import { variableTypeMap } from "./variables";
import { propertyTypeMap } from "./properties";
export const literalValueTypes = T.union("type", _object_spread({}, variableTypeMap, cssTypeMap, propertyTypeMap));
export const literalTypeNames = [
    ...Object.keys(cssTypeMap),
    ...Object.keys(variableTypeMap),
    ...Object.keys(propertyTypeMap)
];
export const literalValueTypeNameValidator = T.literalEnum(...Object.keys(variableTypeMap), ...Object.keys(cssTypeMap), ...Object.keys(propertyTypeMap));
export const valueTypeMap = {
    "value-type": T.object({
        type: T.literal("value-type"),
        value: literalValueTypeNameValidator
    })
};
export const literalTypeValuesAndTypeValue = T.union("type", _object_spread({}, variableTypeMap, cssTypeMap, propertyTypeMap, valueTypeMap));
export * from "./css";
export * from "./variables";
export * from "./properties";
export * from "./resource"; // Editing configs
